// extracted by mini-css-extract-plugin
export default {"questionsList":"statisticsTab_questionsList__tiH+N"};